import { render, staticRenderFns } from "./MaterialUploader.html?vue&type=template&id=f3012f10&"
import script from "./MaterialUploader.ts?vue&type=script&lang=ts&"
export * from "./MaterialUploader.ts?vue&type=script&lang=ts&"
import style0 from "./MaterialUploader.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
